import { CardContainerRetro } from "../Container/CardContainerRetro";
import { Stack } from "@mantine/core";
import { NavLink } from "@mantine/core";
import { Text } from "@mantine/core";
import { Avatar } from "@mantine/core";
import { IconActivityFeed } from "../../assets/icon/menu/IconActivityFeed";
import { IconLifetimeAnalytics } from "../../assets/icon/menu/IconLifetimeAnalytics";
import { useNavigate } from "react-router-dom";
import colorsCustom from "../../designTokens/colorsCustom";
import { IconSearch } from "@tabler/icons-react";
import { IconBooks } from "@tabler/icons-react";
import { IconMessageChatbot } from "@tabler/icons-react";
import { IconUsers } from "@tabler/icons-react";
import { IconSend } from "@tabler/icons-react";
import { IconMessageCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { Group } from "@mantine/core";
import { Link } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";

export const SideMenu = ({ userData, toggle }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const isMobile = useIsMobile("xl");
	const menuList1 = [
		{
			title: t("sidebar.activityFeed"),
			icon: <IconActivityFeed />,
			link: "/dashboard",
		},
		{
			title: t("sidebar.lifetimeAnalytics"),
			icon: <IconLifetimeAnalytics />,
			link: "/analytic",
		},
		{
			title: t("sidebar.searchThreads"),
			icon: <IconSearch size={24} />,
			link: "/search",
		},
		{
			title: t("sidebar.friendsInteraction"),
			icon: <IconMessageCircle size={24} />,
			link: "/friends-interaction",
		},
		{
			title: t("sidebar.postThread"),
			icon: <IconSend size={24} />,
			link: "/post-thread",
		},

		// {
		// 	title: "Repost Curation",
		// 		icon: <IconRepostCuration />,
		// 		link: "/repost-curation",
		// },
	];
	const menuList2 = [
		{
			title: t("sidebar.myCollection"),
			icon: <IconBooks size={24} />,
			link: "/my-page",
		},
		{
			title: t("sidebar.allCollection"),
			icon: <IconMessageChatbot size={24} />,
			link: "/all-collection",
		},
		// {
		// 	title: "All Threaders",
		// 	icon: <IconUsers size={24} />,
		// 	link: "/threaders",
		// },
	];

	const menuList3 = [
		{
			title: t("sidebar.myAccount"),
			icon: <Avatar size={24} src={userData.threads_profile_picture_url} />,
			link: "/account",
		},
		// {
		// 	title: "Manage My Plan",
		// 	icon: <IconPlan />,
		// 	link: "/plan",
		// },
	];
	return (
		<CardContainerRetro
			bg={colorsCustom.paper}
			w={"100%"}
			rd={isMobile ? 0 : 16}
			weight="bold"
		>
			<Stack
				gap={16}
				w={"100%"}
				h={isMobile ? "calc(100vh - 64px)" : "auto"}
				pb={16}
			>
				<Stack
					p={"16 0 0 0"}
					gap={0}
					w={"100%"}
					style={{ borderBottom: "1px solid var(--mantine-color-gray-2)" }}
				>
					<Stack p={"8 0"} gap={0}>
						<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
							Insight & Content
						</Text>
						{menuList1.map((item) => (
							<NavLink
								key={item.title}
								label={item.title}
								leftSection={item.icon}
								p={"12 16"}
								w={"100%"}
								fw={500}
								fs={"sm"}
								onClick={() => {
									navigate(item.link);
									toggle();
								}}
								styles={(theme) => ({
									label: {
										fontSize: theme.fontSizes.lg,
									},
									section: {
										marginRight: theme.spacing.md,
									},
								})}
							/>
						))}
					</Stack>
				</Stack>
				<Stack
					p={"16 0 0 0"}
					gap={0}
					w={"100%"}
					style={{ borderBottom: "1px solid var(--mantine-color-gray-2)" }}
				>
					<Stack p={"8 0"} gap={0}>
						<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
							Collections
						</Text>
						{menuList2.map((item) => (
							<NavLink
								key={item.title}
								label={item.title}
								leftSection={item.icon}
								p={"12 16"}
								w={"100%"}
								fw={500}
								fs={"sm"}
								onClick={() => {
									navigate(item.link);
									toggle();
								}}
								styles={(theme) => ({
									label: {
										fontSize: theme.fontSizes.lg,
									},
									section: {
										marginRight: theme.spacing.md,
									},
								})}
							/>
						))}
					</Stack>
				</Stack>
				{userData && (
					<Stack p={"16 0 0 0"} gap={0}>
						<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
							Setting & Account
						</Text>
						{menuList3.map((item) => (
							<NavLink
								key={item.title}
								label={item.title}
								leftSection={item.icon}
								w={"100%"}
								p={"12 16"}
								fs={"sm"}
								fw={500}
								onClick={() => {
									navigate(item.link);
									toggle();
								}}
								styles={(theme) => ({
									label: {
										fontSize: theme.fontSizes.lg,
									},
									section: {
										marginRight: theme.spacing.md,
									},
								})}
							/>
						))}
					</Stack>
				)}
				<Group
					gap={8}
					justify="center"
					pt={8}
					style={{ borderTop: "1px solid var(--mantine-color-gray-2)" }}
				>
					<Link to="/privacy-policy" style={{ textDecoration: "none" }}>
						<Text size="sm" c="dimmed">
							{t("legal.privacy.shortTitle")}
						</Text>
					</Link>
					<Text size="sm" c="dimmed">
						•
					</Text>
					<Link to="/terms-of-service" style={{ textDecoration: "none" }}>
						<Text size="sm" c="dimmed">
							{t("legal.tos.shortTitle")}
						</Text>
					</Link>
				</Group>
			</Stack>
		</CardContainerRetro>
	);
};
